/**
 * AffiliateService.js
 * Travelpayouts Partner ID 764752 Monetization & Universal Tracking Engine
 * Manages contextual deep-links, sub-channel tracking, and multi-partner revenue routing.
 */

export const TRAVELPAYOUTS_PARTNER_ID = '764752';

export class AffiliateService {
  /**
   * Universal Affiliate Partner Config with Marker 764752
   */
  static PARTNERS = {
    airalo: {
      name: 'Airalo Korea 5G eSIM',
      baseUrl: 'https://www.airalo.com/south-korea-esim',
      affiliateUrl: `https://www.airalo.com/south-korea-esim?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    kkday: {
      name: 'KKday Korea Tours & Passes',
      baseUrl: 'https://www.kkday.com/ko/city/seoul',
      affiliateUrl: `https://www.kkday.com/ko/city/seoul?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    klook: {
      name: 'Klook Korea Attractions',
      baseUrl: 'https://www.klook.com/ko/city/2-seoul-things-to-do/',
      affiliateUrl: `https://www.klook.com/ko/city/2-seoul-things-to-do/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    trip: {
      name: 'Trip.com Hotel Booking',
      baseUrl: 'https://www.trip.com/hotels/list?city=274',
      affiliateUrl: `https://www.trip.com/hotels/list?city=274&marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    goodlugg: {
      name: 'Goodlugg Airport Luggage Delivery',
      baseUrl: 'https://www.goodlugg.com/',
      affiliateUrl: `https://www.goodlugg.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    radical: {
      name: 'Radical Storage Korea Luggage Holding',
      baseUrl: 'https://radicalstorage.com/',
      affiliateUrl: `https://radicalstorage.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    intui: {
      name: 'Intui.travel Airport Taxi & Shuttles',
      baseUrl: 'https://www.intui.travel/en/',
      affiliateUrl: `https://www.intui.travel/en/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    gocity: {
      name: 'Go City Seoul Pass',
      baseUrl: 'https://gocity.com/seoul/en-us',
      affiliateUrl: `https://gocity.com/seoul/en-us?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    arex: {
      name: 'AREX Airport Express & KTX',
      baseUrl: 'https://www.airportrailroad.com/',
      affiliateUrl: `https://www.airportrailroad.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    tiqets: {
      name: 'Tiqets Palace & Museum Fast-Track',
      baseUrl: 'https://www.tiqets.com/en/seoul-attractions-c60312/',
      affiliateUrl: `https://www.tiqets.com/en/seoul-attractions-c60312/?partner=${TRAVELPAYOUTS_PARTNER_ID}&marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    welcomepickups: {
      name: 'Welcome Pickups Airport Transfers',
      baseUrl: 'https://www.welcomepickups.com/',
      affiliateUrl: `https://www.welcomepickups.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    kiwi: {
      name: 'Kiwi.com Flight Booking',
      baseUrl: 'https://www.kiwi.com/',
      affiliateUrl: `https://www.kiwi.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    },
    gigsky: {
      name: 'GigSky Global eSIM & Data',
      baseUrl: 'https://www.gigsky.com/',
      affiliateUrl: `https://www.gigsky.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`
    }
  };

  /**
   * Generate tracked affiliate URL with custom sub_id for revenue analytics
   * @param {string} partnerKey 'airalo' | 'kkday' | 'klook' | 'trip' | 'goodlugg' | 'intui' | 'gocity' | 'arex' | 'tiqets'
   * @param {string} subId tracking sub_id (e.g. 'spot_modal', 'scratchpad_chk', 'top_promo')
   * @param {string} [customKeyword] Optional search keyword for city/spot
   * @returns {string}
   */
  static getTrackedUrl(partnerKey, subId = 'ktour_general', customKeyword = '') {
    const partner = this.PARTNERS[partnerKey];
    if (!partner) return `https://www.travelpayouts.com/?marker=${TRAVELPAYOUTS_PARTNER_ID}`;

    let url = partner.affiliateUrl;
    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}sub_id=${encodeURIComponent(subId)}`;

    if (customKeyword && partnerKey === 'trip') {
      url += `&keyword=${encodeURIComponent(customKeyword)}`;
    } else if (customKeyword && (partnerKey === 'kkday' || partnerKey === 'klook')) {
      url += `&query=${encodeURIComponent(customKeyword)}`;
    }

    return url;
  }

  /**
   * Log outbound affiliate click for telemetry and analytics
   * @param {string} partnerKey 
   * @param {string} subId 
   */
  static logAffiliateClick(partnerKey, subId) {
    try {
      console.log(`[Affiliate Click] Partner: ${partnerKey} | SubID: ${subId} | Marker: ${TRAVELPAYOUTS_PARTNER_ID} | Time: ${new Date().toISOString()}`);
    } catch (e) {
      // noop
    }
  }
}
